import { IPaymentMethod } from '@checkout/state';
import { KlarnaPayments, isKlarnaPayments, klarnaPaymentsUriValues } from './paymentMethods';
import { checkIfArrayOfStringsContainsElement } from './utils';

export const initKlarnaPaymentTerms = (paymentMethodUri: string, eid: string, locale: string) => {
  if (paymentMethodUri.includes(KlarnaPayments.invoiceUri)) {
    // tslint:disable-next-line:no-unused-expression
    return new Klarna.Terms.Invoice({ // eslint-disable-line no-new
      el: paymentMethodUri, // id of link element
      eid,
      locale,
      charge: 0,
      type: 'desktop',
    });
  } else {
    // tslint:disable-next-line:no-unused-expression
    return new Klarna.Terms.Account({ // eslint-disable-line no-new
      el: paymentMethodUri, // id of link element
      eid,
      locale,
      charge: 0,
      type: 'desktop',
    });
  }

};

export const isScripLoaded = (url: string): boolean => {
  return Array
    .from(document.querySelectorAll('script'))
    .some(({ src }) => src === url);
};

export const loadKlarnaTermsLib = () => {
  const klarnaTermsScriptUrl = 'https://cdn.klarna.com/public/kitt/toc/v1.1/js/klarna.terms.min.js';

  if (!isScripLoaded(klarnaTermsScriptUrl)) {
    const klarnaTerms = document.createElement('script');
    klarnaTerms.src = klarnaTermsScriptUrl;
    if (document && document.head) {
      document.head.appendChild(klarnaTerms);
    }
  }
};

export const loadKlarnaInvoiceLib = () => {
  const klarnaInvoiceScriptUrl = 'https://cdn.klarna.com/public/kitt/core/v1.0/js/klarna.min.js';

  if (!isScripLoaded(klarnaInvoiceScriptUrl)) {
    const klarnaInvoice = document.createElement('script');
    klarnaInvoice.src = klarnaInvoiceScriptUrl;
    if (document && document.head) {
      document.head.appendChild(klarnaInvoice);
    }
    klarnaInvoice.onload = () => (loadKlarnaTermsLib());
  }
};

export const loadTermsLink = (paymentMethod: IPaymentMethod) => {
  if (paymentMethod.clientSide) {
    const { paymentMethod: paymentMethodValue } = paymentMethod;
    const { locale, eid } = paymentMethod.clientSide;

    initKlarnaPaymentTerms(paymentMethodValue, eid, locale);
  }
};

export const loadTermsLinksForKlarna = (paymentMethods: IPaymentMethod[]) => {
  paymentMethods.map((paymentMethod: IPaymentMethod) => {
    if (paymentMethod.clientSide && checkIfArrayOfStringsContainsElement(klarnaPaymentsUriValues, paymentMethod.paymentMethod)) {
      loadTermsLink(paymentMethod);
    }
  });
};

export const renderKlarnaPaymentTermsLink = (paymentMethods: IPaymentMethod[]) => {
  if (isKlarnaPayments(paymentMethods)) {
    loadKlarnaInvoiceLib();

    const checkIfKlarnaIsLoaded = setInterval(() => {
      if (typeof (Klarna) !== 'undefined' && typeof (Klarna.Terms) !== 'undefined') {
        clearInterval(checkIfKlarnaIsLoaded);
        loadTermsLinksForKlarna(paymentMethods);
      }
    }, 70);
  }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/klarnaTerms.ts